'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckIcon = function (_React$Component) {
    _inherits(CheckIcon, _React$Component);

    function CheckIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CheckIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckIcon.__proto__ || Object.getPrototypeOf(CheckIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (isDisable) {
            return _react2.default.createElement(
                'svg',
                { id: 'icon_action_check_circle_24px', 'data-name': 'icon/action/check_circle_24px', xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Boundary', width: '24', height: '24', fill: 'none' }),
                _react2.default.createElement('path', { id: '_Color', 'data-name': ' \u21B3Color', d: 'M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM4.41,8.59h0L3,10l5,5,9-9L15.59,4.58,8,12.17,4.41,8.59Z', transform: 'translate(2 2)', fill: isDisable ? '#999999' : _colors.Colors.Primary })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CheckIcon, [{
        key: 'render',
        value: function render() {
            var isDisable = this.props.disable ? true : false;
            return this.getIcon(isDisable);
        }
    }]);

    return CheckIcon;
}(_react2.default.Component);

exports.default = CheckIcon;